const aboutDriven =[
    {
      id: 0,
      icon: require("./../../assets/images/about/icon-principles-beliefs.png"),
      title: "Principles and Beliefs    ",
      desc: `Honesty, integrity, and permissibility form the core of our principles, 
rooted in ethical values. These timeless ideals guide our conviction 
and resonate through every step of our journey.

      `
    },
    {
      id: 1,
      icon: require("./../../assets/images/about/icon-exceptionalism-high-standards.png"),
      title: "Customer Centricity      ",
      desc: `Prioritizing the needs of customers by providing user-friendly, 
customizable, and integrated solutions that enhance 
productivity and engagement.

      `
    },
    {
      id: 2,
      icon: require("./../../assets/images/about/icon-customer-experience-satisfaction.png"),
      title: "Collaboration",
      desc: `Encouraging teamwork and collaboration both internally 
and with customers, leveraging Teamwork across the 
SmartOffice ecosystem.

      `
    },
    {
      id: 3,
      icon: require("./../../assets/images/about/icon-principles-beliefs.png"),
      title: "Integrity and Trust ",
      desc: `Building and maintaining trust through transparent 
business practices and reliable products that 
customers can depend on.
      `
    },
    {
      id: 4,
      icon: require("./../../assets/images/about/icon-exceptionalism-high-standards.png"),
      title: "Inclusivity     ",
      desc: `Embracing diversity and inclusion, ensuring that solutions 
are accessible and beneficial to a wide range of 
users across different industries and regions.

      `
    },
    {
      id: 5,
      icon: require("./../../assets/images/about/icon-customer-experience-satisfaction.png"),
      title: "Innovation",
      desc: `Continuously pushing the boundaries of technology 
to provide cutting-edge solutions that drive business 
growth and transformation.

      `
    },
    
  ]

  export { aboutDriven }

